var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view-panel_config"}},[_c('PanelConfig')],1)}
var staticRenderFns = []

export { render, staticRenderFns }